import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { merge, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[luiIfBreakpoint]',
  standalone: true,
})
export class IfBreakpointDirective implements AfterViewInit, OnDestroy {
  @Input() get luiIfBreakpoint() {
    return this._mediaQuery;
  }
  set luiIfBreakpoint(mediaQuery: string) {
    this._mediaQuery = mediaQuery;

    this._mediaQueryChange.next();

    this.bpo
      .observe(this.luiIfBreakpoint)
      .pipe(takeUntil(merge(this._mediaQueryChange, this._destroy)))
      .subscribe(({ matches }) => {
        if (matches) {
          this.view.createEmbeddedView(this.template);
        } else {
          this.view.clear();
        }
      });
  }
  private _mediaQuery!: string;

  _mediaQueryChange = new Subject<void>();
  _destroy = new Subject<void>();

  constructor(
    private bpo: BreakpointObserver,
    private view: ViewContainerRef,
    private template: TemplateRef<any>
  ) {}

  ngAfterViewInit(): void {
    console;
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
    this._mediaQueryChange.complete();
  }
}
